export default state => state.timezones;
